
import React from 'react';
import ArtistsContainer from './containers/ArtistsContainer';


const artists = () => <ArtistsContainer />;

export default artists;
